import React, { useEffect } from "react";
import { useSelectedLocation } from "../contexts/SelectedLocationContext";
import { Tab } from "../types/Tab";
import PageContainer from "../components/PageContainer";
import PageSection from "../components/PageSection";
import { useDocumentMeta } from "../hooks/useDocumentMeta";

const PodcastPage: React.FC = () => {
  const { setDomain, setCategory, setProduct } = useSelectedLocation();
  useDocumentMeta({
    title: "The Americana Podcast",
    description:
      "A podcast on the culture and history of America, from The Americana Company.",
  });

  useEffect(() => {
    setDomain(Tab.Podcast.toString());
    setCategory(null);
    setProduct(null);
  }, [setDomain, setCategory, setProduct]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top
  }, []); // Runs only once when the component mounts

  return (
    <PageContainer>
      <PageSection className="hero">
        <h1>The Americana Podcast</h1>
        <p>
          We are creating a podcast to discuss the culture and history of
          America to go along with our product line!
        </p>
      </PageSection>
      <PageSection className="content">
        <h2 className="playfair-text text-2xl text-brown-dark">Coming Soon…</h2>
      </PageSection>
    </PageContainer>
  );
};

export default PodcastPage;
